import CommonStore from "../common_store";
import { action, makeObservable, observable, runInAction } from "mobx";
import api from "../../../api";
class TaskManageStore {
  commonStore?: CommonStore;

  constructor(baseStore?: CommonStore) {
    this.commonStore = baseStore;
    makeObservable(this);
  }
  @observable searchForm: any = {};
  @observable tableData: any = {};
  //表格加载状态
  @observable tableLoad: boolean = true;
  //分页信息
  @observable pageData: IPageData = {
    page: 1,
    size: 10,
    changePage: (page: number, size: number) => {
      runInAction(() => {
        this.pageData.page = page;
        this.pageData.size = size;
        this.pageData = { ...this.pageData };
      });
      this.getTaskPage();
    },
  };
  setSearchForm(obj: any) {
    runInAction(() => {
      this.searchForm = obj;
    });
  }
  //重置分页
  resetPage() {
    runInAction(() => {
      this.pageData.page = 1;
    });
  }

  //分页查询
  @action
  getTaskPage() {
    this.commonStore?.getPagePermission("calling_card_signature_management");
    runInAction(() => {
      this.tableData = {};
      this.tableLoad = true;
    });
    const data = { ...this.searchForm };
    data.size = this.pageData.size;
    data.page = this.pageData.page;
    api.taskApi
      .getTaskPage(data)
      .then((res: any) => {
        if (res.code == 200) {
          runInAction(() => {
            this.tableData = res.data;
            this.tableData = { ...this.tableData };
            this.tableLoad = false;
          });
        }
      })
      .catch((e: any) => {
        runInAction(() => {
          this.tableLoad = false;
        });
      });
  }
}

export default TaskManageStore;
